export const enum LayoutActionTypes {
  SECTION_VIEW_SELECTED = '[layout]SECTION_VIEW_SELECTED',
  SHOW_NAVBAR = '[layout]SHOW_NAVBAR',
  HIDE_NAVBAR = '[layout]HIDE_NAVBAR'
}

export interface LayoutState {
  readonly selectedSection: string | null;
  readonly navbarDropdown: boolean;
}



// WEBPACK FOOTER //
// ./src/store/layout/types.ts